import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { AlertActionsUnion, DangerAlert, SuccessAlert } from '@shared/alert';
import {
  addCandidatesToTalentPoolsFail,
  addCandidatesToTalentPoolsSuccess,
} from 'mojo-talent-pools';
@Injectable()
export class CandidateSideNavEffects {
  addSuccess$: Observable<AlertActionsUnion> = createEffect(() =>
    this.actions$.pipe(
      ofType(addCandidatesToTalentPoolsSuccess),
      map(() => new SuccessAlert('Candidates have been added to talent pools')),
    ),
  );
  addFail$: Observable<AlertActionsUnion> = createEffect(() =>
    this.actions$.pipe(
      ofType(addCandidatesToTalentPoolsFail),
      map(
        () => new DangerAlert('A problem occurred while trying to add candidates to talent pools'),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<{}>,
    private talentPoolService: TalentPoolsService,
  ) {}
}
